import { render, staticRenderFns } from "./FaceDeleteModal.vue?vue&type=template&id=80b45ee6"
import script from "./FaceDeleteModal.vue?vue&type=script&lang=ts"
export * from "./FaceDeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports